var map = {
	"./Error404.vue": [
		16080,
		8974
	],
	"./PressRelease.vue": [
		96330,
		9700
	],
	"./Root.vue": [
		67838
	],
	"./RouterWrapperPage.vue": [
		85000
	],
	"./Stories.vue": [
		48644,
		9105
	],
	"./StoryFull.vue": [
		96292,
		2094
	],
	"./Terms.vue": [
		20475,
		4931
	],
	"./UserActivation.vue": [
		28740,
		915,
		8497
	],
	"./UserPasswordReset.vue": [
		38879,
		915,
		1989
	],
	"./Wrapper.vue": [
		38790
	],
	"./_redirect/FirstNewsroomEdit.vue": [
		49701,
		3656
	],
	"./auth/Auth.vue": [
		87147,
		5763
	],
	"./auth/ForgottenPassword.vue": [
		90072,
		915,
		3672
	],
	"./auth/Login.vue": [
		85595,
		915,
		598
	],
	"./dashboard/Dashboard.vue": [
		29733,
		993
	],
	"./dashboard/DashboardAlerts.vue": [
		16819,
		2580
	],
	"./dashboard/DashboardSuggestedNewsrooms.vue": [
		23602,
		8941
	],
	"./dashboard/DashboardSuggestedStories.vue": [
		31953,
		6381
	],
	"./embedded/EmbeddedNewsroom.vue": [
		4066,
		2331
	],
	"./embedded/EmbeddedNewsroomStories.vue": [
		50203,
		1584
	],
	"./embedded/EmbeddedStory.vue": [
		65625,
		5676
	],
	"./embedded/Index.vue": [
		53738,
		2777
	],
	"./marketing/ForBrands.vue": [
		75673,
		4514
	],
	"./marketing/ForJournalists.vue": [
		24249,
		915,
		5156,
		968
	],
	"./newsroom/Newsroom.vue": [
		65808,
		6271
	],
	"./newsroom/NewsroomAbout.vue": [
		67952,
		6864,
		4136
	],
	"./newsroom/NewsroomAssets.vue": [
		43146,
		4132
	],
	"./newsroom/NewsroomStories.vue": [
		58018,
		5956
	],
	"./newsroomEdit/NewsroomEdit.vue": [
		55133,
		5156,
		8663
	],
	"./newsroomEdit/NewsroomEditAbout.vue": [
		54391,
		6864,
		7987
	],
	"./newsroomEdit/NewsroomEditAssets.vue": [
		52326,
		6956
	],
	"./newsroomEdit/NewsroomEditStories.vue": [
		69163,
		3132
	],
	"./registrations/FreeNewsroomLanding2.vue": [
		99020,
		915,
		5156,
		5768
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 54294;
module.exports = webpackAsyncContext;